import React from 'react';
import useInView from '../../hooks/useInView';
import styles from './WhyUs.module.css';

const reasons = [
  { icon: '🎯', title: 'Индивидуальный подход', text: 'Разрабатываем стратегию под каждого клиента с учётом специфики товара и направления' },
  { icon: '📊', title: 'Комплексное решение', text: 'От первой консультации до получения груза — полный цикл сопровождения ВЭД' },
  { icon: '🔒', title: 'Юридическая защита', text: 'Обеспечиваем правовую чистоту всех сделок и документов для вашей безопасности' },
  { icon: '🌍', title: 'Международный опыт', text: 'Работаем с поставщиками и покупателями из Европы, Турции, Китая, Индии и Вьетнама' },
  { icon: '⚡', title: 'Оперативность', text: 'Быстрая обработка заявок и оперативное решение возникающих вопросов' },
  { icon: '💼', title: 'Более 20 лет опыта', text: 'Юристы, логисты и специалисты по ВЭД работают с 2006 года' }
];

export default function WhyUs() {
  const [ref, isVisible] = useInView();

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.container}>
        <div style={{ textAlign: 'center' }}>
          <span className={styles.badge}>Преимущества</span>
        </div>
        <h2 className={styles.title}>Почему выбирают нас</h2>
        <p className={styles.subtitle}>
          Мы объединяем экспертизу в праве, логистике и таможенном оформлении для достижения ваших целей
        </p>
        <div className={styles.grid}>
          {reasons.map((r, i) => (
            <div
              className={`${styles.card} ${isVisible ? styles.cardVisible : ''}`}
              key={i}
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <div className={styles.icon}>{r.icon}</div>
              <h4 className={styles.cardTitle}>{r.title}</h4>
              <p className={styles.cardText}>{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
